import { Button } from '@azelis/ui/components/button';
import { TabsContent } from '@azelis/ui/components/tabs';

import type { SharePointDocument } from '@/api/types';

import { DocumentCheckboxList } from './document-checkbox-list';
import { DocumentsColumn } from './documents-column';

/** Middle column: checkbox list of documents in the currently selected drive. */
export function DriveDocumentsColumn({
  driveAllSelected,
  drives,
  grouped,
  onToggleDocument,
  onToggleDriveAll,
  selectedDocumentIds,
  selectedDriveIds,
}: {
  driveAllSelected: boolean;
  drives: Array<string>;
  grouped: Map<string, Array<SharePointDocument>>;
  onToggleDocument: (id: string) => void;
  onToggleDriveAll: (ids: Array<string>) => void;
  selectedDocumentIds: Array<string>;
  selectedDriveIds: Array<string>;
}) {
  return (
    <DocumentsColumn
      action={
        <Button
          disabled={selectedDriveIds.length === 0}
          type="button"
          onClick={() => {
            onToggleDriveAll(selectedDriveIds);
          }}
        >
          {driveAllSelected ? 'Deselect all' : 'Select all'}
        </Button>
      }
      className="min-w-0 flex-1"
      title="Documents"
    >
      {drives.map((drive) => (
        <TabsContent key={drive} value={drive}>
          <DocumentCheckboxList
            documents={grouped.get(drive) ?? []}
            selectedDocumentIds={selectedDocumentIds}
            onToggle={onToggleDocument}
          />
        </TabsContent>
      ))}
    </DocumentsColumn>
  );
}
